import React from "react";

const InquirySection = () => {

    return (

        <div className="card inquiry-section">

            <div className="inquiry-logo">

                BSB For Trade

            </div>

            <p className="inquiry-text">

                Looking for the best plastic raw material deals?
                Send your requirement and get offers from verified suppliers.

            </p>

            <button className="btn-primary">

                Send Inquiry

            </button>

        </div>

    );

};

export default InquirySection;